import indexTransition from './timelines/indexTransition';
import eventTransition from './timelines/eventTransition';


const transition = new Map();

transition.set('index', indexTransition);
transition.set('event', eventTransition);

export default transition;



// WEBPACK FOOTER //
// ./src/scripts/transitions.js